/**
 * Délégation : boutons .hia-quick-atc (home, suggestions produit, contenu injecté)
 */
(function () {
  var checkSvg =
    '<svg class="hia-quick-atc__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  var cartSvg =
    '<svg class="hia-quick-atc__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';

  function replaceIcon(btn, html) {
    var icon = btn.querySelector('.hia-quick-atc__icon');
    if (!icon) return;
    if (icon.tagName && icon.tagName.toLowerCase() === 'svg') {
      icon.outerHTML = html;
    } else {
      icon.innerHTML = html;
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.hia-quick-atc');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var vid = btn.dataset.vid;
      var url = btn.dataset.url;
      var label = btn.querySelector('.hia-quick-atc__label');
      if (!vid) return;

      btn.disabled = true;
      if (label) label.textContent = 'Ajout…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          replaceIcon(btn, checkSvg);
          if (label) label.textContent = 'Ajouté !';
          if (btn.dataset.refreshCart === 'true') {
            var onCartPage = /\/cart\/?$/.test(window.location.pathname);
            if (onCartPage) {
              window.location.reload();
              return;
            }
            if (btn.dataset.pid) {
              document.querySelectorAll('.ecd-cross-sell__card[data-pid="' + btn.dataset.pid + '"]').forEach(function (card) {
                card.hidden = true;
              });
            }
            if (window.EmaCartDrawer) {
              window.EmaCartDrawer.refresh();
            }
            setTimeout(function () {
              btn.disabled = false;
              replaceIcon(btn, cartSvg);
              if (label) label.textContent = btn.closest('.ecd-cross-sell') ? 'Ajouter' : 'Ajouter au panier';
            }, 2000);
            return;
          }
          if (window.EmaCartDrawer) {
            window.EmaCartDrawer.refresh();
            window.EmaCartDrawer.open();
          }
          setTimeout(function () {
            btn.disabled = false;
            replaceIcon(btn, cartSvg);
            if (label) label.textContent = 'Ajouter au panier';
          }, 2000);
        })
        .catch(function () {
          btn.disabled = false;
          if (label) label.textContent = 'Ajouter au panier';
          if (url) window.location.href = url;
        });
    },
    false
  );
})();
